import React from 'react';
import { PropTypes } from 'prop-types';
import { withStyles } from '@mui/styles';
import { Icon, Typography, Tooltip } from '@mui/material';
import { yearFromDateOnly } from 'utils';

const styles = (theme) => ({
  inactiveIcon: {
    verticalAlign: 'text-top',
    // Small left gap so it sits correctly both after a provider's name (detail
    // page header) and beside the affiliated icon (Locations providers table).
    marginLeft: theme.spacing(0.5),
    // Deliberately muted rather than palette.secondary.main: this marks an
    // absence, not an achievement.
    color: theme.palette.text.disabled,
  },
  inactiveInfoTip: {
    fontSize: 13,
    fontWeight: 200,
  },
});

/**
 * Marks a provider who is no longer practicing for the selected client.
 *
 * Their historical data is untouched and still appears in every chart and
 * report — claims trail by up to 15 months, so an inactive provider keeps
 * showing volume. The year is what explains that, so show it whenever we
 * have one.
 */
class InactiveIcon extends React.Component {
  render() {
    const { classes, inactiveAt, fontSize } = this.props;

    // Year only, deliberately — the full date is stored but never shown.
    // Liaisons know the season someone left, not the day, and a precise-looking
    // date invites a precision the data does not have.
    const year = yearFromDateOnly(inactiveAt);
    const label = year ? `Inactive ${year}` : 'Inactive';

    return (
      <Tooltip
        placement='bottom-start'
        title={(
          <Typography className={classes.inactiveInfoTip}>
            {label}
          </Typography>
        )}
      >
        <Icon className={classes.inactiveIcon} style={{ fontSize }}>event_busy</Icon>
      </Tooltip>
    );
  }
}

InactiveIcon.propTypes = {
  classes: PropTypes.object,
  inactiveAt: PropTypes.string,
  // Defaults to a size that sits well against 12-13px table text. The provider
  // detail header passes 'inherit', because its title is fluid and a fixed 18px
  // marker would render larger than the name on a narrow viewport.
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

InactiveIcon.defaultProps = {
  fontSize: 18,
};

const styled = withStyles(styles)(InactiveIcon);
export { styled as InactiveIcon };
